import { Injectable } from '@angular/core';
import {ConfigurationDataProvider} from '../configuration-data-provider';
import {SharedDataProvider} from '../shared-data-provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {TaskSearchRequest} from '../dto/task';

@Injectable()
export class TaskSearchProvider {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  constructor(public http: HttpClient, private config : ConfigurationDataProvider, private shared: SharedDataProvider) {
  }

  /**
   * Search all locations which belong to loggedin user.
   */
  public searchTask(request: TaskSearchRequest) {
    request.credentials = this.shared.getTokenAuthData();
    console.log("Call: "+ this.config.taskSearchURL + "tss data: " + JSON.stringify(request));
    return this.http.post(this.config.taskSearchURL+"tss", JSON.stringify(request), {headers: this.headers});
  }
}



// WEBPACK FOOTER //
// ./src/providers/task-search/task-search.ts